export default {
  title: "Акции",
  newPromotion: "Новая акция",
  createNewPromo: "Создать новую акцию",
  creatingNewPromo: "Создание новой акции",
  name: "Название акции",
  promoEditor: "Редактор акций",
  cashback: "Процент начисления",
  discount: "Процент скидки",
  activate: "Активировать акцию",
  deactivate: "Деактивировать акцию",
  noPromotions: "У вас еще нет акций",
  createWarning: "*До трёх активированных акций\n на одну торговую точку",
  createWarningLimit:
    "Создано максимальное количество акций для данной торговой точки",
  headersList: {
    name: "Название акции",
    tradingPoint: "Торговая точка",
    cashback: "Процент начисления",
    discount: "Процент скидки",
  },
  delete: "Вы уверены, что хотите удалить ",
  aboutChapter: "О подразделе",
  aboutChapterDescriptions: [
    "Подраздел «Акции» помогает проводить товары с разным значением скидки и разным значением начисления вознаграждения. Созданная вами акция отобразится в приложении RC KASSA и может быть сразу применена.",
    "У одной торговой точки одновременно может быть до 3-х активированных акций.",
  ],
  deletePromo: "Удалить акцию",
};
